import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import SectionHeader from "../../../components/home/membershipPlanComponents/SectionHeader";
import WishlistItem from "../../../components/home/wishlistComponent/BookWishlistItem";
import EmptyWishlist from "../../../components/home/wishlistComponent/EmptyWishlist";

import {
  fetchWishlist,
  removeFromWishlistAsync,
} from "../../../features/wishlistSlice";
import { addToCartAsync } from "../../../features/cartSlice";

export default function Wishlist() {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.user?.userId);
  const { items, status, error } = useSelector((state) => state.wishlist);

  useEffect(() => {
    if (userId) {
      dispatch(fetchWishlist(userId));
    }
  }, [userId, dispatch]);

  console.log("Wishlist Items:", items);

  const handleRemove = (bookId) => {
    dispatch(removeFromWishlistAsync({ userId, bookId }));
  };

  const handleAddToCart = (book) => {
    dispatch(addToCartAsync({ userId, book }));
  };

  if (status === "loading") {
    return <div className="p-8">Loading wishlist...</div>;
  }

  if (status === "failed") {
    return <div className="p-8 text-red-500">{error}</div>;
  }

  return (
   <section className="w-full">
  {/* Full-width section header */}
  <div className="w-full">
    <SectionHeader title="My Wishlist" />
  </div>

  {/* Wishlist items centered */}
  <div className="max-w-3xl mx-auto px-4 sm:px-6 md:px-0 py-6">
    {items.length === 0 ? (
      <EmptyWishlist />
    ) : (
      items.map((bookWrapper, index) => {
        const book = bookWrapper.book;
        if (!book) return null;

        const imageUrl = bookWrapper.bookImages?.[0] || "/default-cover.jpg";

        const formattedDate = bookWrapper.creationDate
          ? new Date(
              bookWrapper.creationDate[0],
              bookWrapper.creationDate[1] - 1,
              bookWrapper.creationDate[2],
              bookWrapper.creationDate[3],
              bookWrapper.creationDate[4],
              bookWrapper.creationDate[5]
            ).toLocaleDateString()
          : "N/A";

        return (
          <WishlistItem
            key={book.bookId || index}
            book={book}
            imageUrl={imageUrl}
            date={formattedDate}
            onAddToCart={() => handleAddToCart(book)}
            onRemove={() => handleRemove(book.bookId)}
          />
        );
      })
    )}
  </div>
</section>

  );
}
